import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useCustomer } from "@/context/CustomerContext";

export const inputCls = "w-full rounded border border-kys-blush-border bg-white px-3 py-2.5 text-sm focus:border-kys-accent focus:outline-none";
export const btnCls = "flex w-full items-center justify-center gap-2 rounded-full bg-kys-ink py-3 text-sm font-semibold text-white transition hover:bg-kys-accent disabled:opacity-60";

export function AuthCard({ title, subtitle, children, testid }) {
  return (
    <div className="mx-auto flex max-w-md flex-col px-4 py-14 sm:py-20" data-testid={testid}>
      <p className="label-accent text-kys-accent">My Account</p>
      <h1 className="mt-2 font-serif text-4xl tracking-tight text-kys-ink">{title}</h1>
      {subtitle && <p className="mt-2 text-sm text-kys-muted">{subtitle}</p>}
      <div className="mt-8 rounded-lg border border-kys-blush-border bg-white p-6 shadow-sm shadow-kys-blush-soft sm:p-7">{children}</div>
    </div>
  );
}

export function FieldLabel({ children }) {
  return <label className="mb-1 block text-xs font-medium text-kys-charcoal">{children}</label>;
}

export function Notice({ kind = "error", children, testid }) {
  const cls = kind === "error" ? "bg-red-50 text-red-600" : "bg-kys-blush text-kys-charcoal";
  return <p data-testid={testid} className={`mb-4 rounded px-3 py-2 text-sm ${cls}`}>{children}</p>;
}

export function RequireCustomer({ children }) {
  const { customer, ready } = useCustomer();
  const loc = useLocation();
  if (!ready) return <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin text-kys-accent" /></div>;
  if (!customer) return <Navigate to={`/account/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  return children;
}
